// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucidePanelsTopBottom as RawLucidePanelsTopBottom } from "lucide-react";
export const LucidePanelsTopBottom = /* @__PURE__ */ createIcon(RawLucidePanelsTopBottom, "LucidePanelsTopBottom", 2);
